import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import strings from "../../locales/strings";

import styles from "./StarsIcons.scss";

const cx = classnames.bind(styles);

const StarsIcons = ({ baseUrl, imgClassName, atiCode, imageLink }) => (
  <img
    className={cx("stars", imgClassName)}
    src={imageLink || `https://${baseUrl}/webapi/icons/v1/stars?id=${atiCode}`}
    alt={strings.stars}
    data-name="stars-link-img"
    loading="lazy"
  />
);

StarsIcons.defaultProps = {
  baseUrl: "ati.su",
};

StarsIcons.propTypes = {
  imageLink: PropTypes.string,
  atiCode: PropTypes.string,
  imgClassName: PropTypes.string,
  baseUrl: PropTypes.string,
};

export default StarsIcons;
